import Button from '@components/Button';
import styled from '@emotion/styled';

import useSignIn from '../../hooks/useSignIn';

function SignInFooter() {
  const { login, isVerified } = useSignIn();
  return (
        <Container>
            <Button onClick={login}
                    fullWidth
                    disabled={!isVerified}>
                로그인
            </Button>
        </Container>
  );
}

const Container = styled.div`
    padding: 0 20px 28px;
    width: 100%;
`;

export default SignInFooter;
